import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import englishFlag from '../assets/images/united-states.svg';
import frenchFlag from '../assets/images/france.svg';
import dutchFlag from '../assets/images/netherlands.svg';
import portugalFlag from '../assets/images/portugal.svg';

const languages = [
    { code: 'en', name: 'English', flag: englishFlag },
    { code: 'fr', name: 'Français', flag: frenchFlag },
    { code: 'nl', name: 'Nederlands', flag: dutchFlag },
    { code: 'pt', name: 'Português', flag: portugalFlag }
];

const LanguageSelector = ({ onClose = () => { } }) => {
    const { i18n } = useTranslation();

    // Initialize language from localStorage or browser
    const getInitialLanguage = () => {
        const savedLang = localStorage.getItem('selectedLanguage');
        if (savedLang) return savedLang;

        // Check browser language
        const browserLang = navigator.language.split('-')[0];
        return languages.find(lang => lang.code === browserLang) ? browserLang : 'en';
    };

    const [selectedLanguage, setSelectedLanguage] = useState(getInitialLanguage);

    // Track if component has mounted to avoid initial language change
    const isMountedRef = React.useRef(false);
    const prevLanguageRef = React.useRef(selectedLanguage);

    // Initialize i18n language on mount
    useEffect(() => {
        const initLanguage = async () => {
            const initialLang = getInitialLanguage();
            const currentLang = i18n.language?.split('-')[0] || i18n.language;
            if (currentLang !== initialLang) {
                await i18n.changeLanguage(initialLang);
            }
            isMountedRef.current = true;
            prevLanguageRef.current = initialLang;
        };
        initLanguage();
    }, []);

    // Handle language change when user selects a different language
    useEffect(() => {
        // Skip if component hasn't mounted yet or language hasn't changed
        if (!isMountedRef.current || prevLanguageRef.current === selectedLanguage) {
            return;
        }

        const changeLanguage = async () => {
            try {
                await i18n.changeLanguage(selectedLanguage);
                localStorage.setItem('selectedLanguage', selectedLanguage);
                prevLanguageRef.current = selectedLanguage;

                // Force re-render of all components using translations
                window.dispatchEvent(new CustomEvent('i18nLanguageChanged', {
                    detail: { language: selectedLanguage }
                }));
            } catch (error) {
                console.error('Error changing language:', error);
            }
        };

        changeLanguage();
    }, [selectedLanguage]);

    return (
        <>
            <Dropdown className="language-selector">
                <Dropdown.Toggle
                    variant="light"
                    id="language-dropdown"
                    className="d-flex align-items-center"

                >
                    <img src={languages.find(lang => lang.code === selectedLanguage)?.flag} alt={languages.find(lang => lang.code === selectedLanguage)?.name} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {languages.map((language) => (
                        <Dropdown.Item
                            key={language.code}
                            onClick={() => setSelectedLanguage(language.code)}
                            className="d-flex align-items-center gap-2"
                        >
                            <img style={{ width: '20px', height: '20px', marginRight: '8px' }} src={language.flag} alt={language.name} />
                            <span>{language.name}</span>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            {/* <div className="language-modal-content">
                <div className="language-modal-header">
                    <h2 className="language-modal-title">Select Language</h2>
                    <button className="language-modal-close" id="languageModalClose" aria-label="Close" onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="language-modal-body">
                    {languages.map((language) => (
                        <button className={`language-option ${selectedLanguage === language.code ? 'active' : ''}`} data-lang={language.code} onClick={() => setSelectedLanguage(language.code)}>
                            <span className="language-flag">
                                <img src={language.flag} alt={language.name} />
                            </span>
                            <span className="language-name">{language.name}</span>
                            {selectedLanguage === language.code && (
                                <svg className="language-check" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="#1C4CAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </button>
                    ))}
                </div>
            </div> */}
        </>
    );
};

export default LanguageSelector; 